var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37.50782mm",
    height: "17.84831mm",
    viewBox: "0 0 37.50782 17.848311",
    id: "svg1092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2420",
    transform: "matrix(0.14533662,0,0,-0.14321007,0.172442,5.0392177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -54.058",
    style: {
      fill: "none",
      stroke: "#1b1768",
      strokeWidth: 2.373,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2422"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2566",
    transform: "matrix(0.14533662,0,0,-0.14321007,15.540215,8.6852029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 7.352 V -1.208 L 5.726,-1.353 5.236,-1.755 v -7.05 C 4.049,-9.15 2.948,-9.409 1.937,-9.582 c -1.01,-0.172 -1.942,-0.259 -2.795,-0.259 -0.978,0 -1.895,0.101 -2.752,0.303 -0.859,0.201 -1.632,0.493 -2.322,0.877 -1.582,0.901 -2.825,2.158 -3.73,3.769 -0.906,1.612 -1.359,3.381 -1.359,5.31 0,3.126 0.954,5.612 2.861,7.459 1.907,1.847 4.475,2.769 7.704,2.769 0.892,0 1.811,-0.072 2.76,-0.215 0.949,-0.144 1.917,-0.36 2.904,-0.648 V 5.107 H 3.563 L 3.119,7.783 2.705,8.315 c -0.557,0.26 -1.11,0.452 -1.662,0.577 -0.552,0.124 -1.115,0.186 -1.69,0.186 -2.274,0 -4.065,-0.753 -5.374,-2.259 -1.309,-1.506 -1.964,-3.572 -1.964,-6.2 0,-2.753 0.678,-4.923 2.036,-6.511 1.357,-1.587 3.201,-2.38 5.531,-2.38 0.451,0 0.929,0.031 1.432,0.093 0.504,0.063 1.029,0.16 1.575,0.295 v 6.129 L 2.086,-1.353 0,-1.208 Z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2568"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2570",
    transform: "matrix(0.14533662,0,0,-0.14321007,17.384468,7.055487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.479,0 0.885,-0.167 1.216,-0.503 0.33,-0.336 0.496,-0.739 0.496,-1.209 0,-0.47 -0.166,-0.868 -0.496,-1.193 C 0.885,-3.231 0.479,-3.395 0,-3.395 c -0.471,0 -0.871,0.164 -1.201,0.49 -0.331,0.325 -0.497,0.723 -0.497,1.193 0,0.48 0.166,0.885 0.497,1.216 C -0.871,-0.165 -0.471,0 0,0 m -0.115,-6.546 h 1.15 v -12.632 l 0.504,-0.474 1.583,-0.144 v -1.064 h -6.618 v 1.064 l 1.554,0.144 0.503,0.474 v 10.661 h -2.057 v 0.921 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2574",
    transform: "matrix(0.14533662,0,0,-0.14321007,19.35417,9.6556376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 5.194 C -2.466,4.513 -4.084,3.89 -4.856,3.324 -5.628,2.758 -6.014,2.015 -6.014,1.094 c 0,-0.739 0.213,-1.326 0.64,-1.763 0.427,-0.436 1,-0.654 1.719,-0.654 0.461,0 0.991,0.11 1.59,0.331 C -1.466,-0.771 -0.777,-0.441 0,0 m 0,-0.992 c -0.95,-0.653 -1.82,-1.135 -2.611,-1.446 -0.792,-0.312 -1.533,-0.468 -2.223,-0.468 -1.142,0 -2.056,0.345 -2.741,1.036 -0.686,0.69 -1.029,1.601 -1.029,2.733 0,1.257 0.515,2.245 1.546,2.964 1.032,0.72 3.384,1.521 7.058,2.402 v 0.936 c 0,1.237 -0.202,2.096 -0.604,2.575 -0.404,0.48 -1.104,0.72 -2.101,0.72 -0.374,0 -0.743,-0.039 -1.108,-0.115 -0.365,-0.077 -0.744,-0.193 -1.136,-0.346 V 7.524 h -2.03 c -0.354,0 -0.596,0.066 -0.726,0.195 -0.129,0.13 -0.194,0.367 -0.194,0.712 0,0.96 0.554,1.756 1.662,2.388 1.107,0.633 2.539,0.95 4.295,0.95 1.544,0 2.666,-0.336 3.366,-1.007 0.7,-0.671 1.051,-1.75 1.051,-3.238 V -1.021 L 2.978,-1.496 4.531,-1.64 V -2.704 H 0.388 Z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2576"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2578",
    transform: "matrix(0.14533662,0,0,-0.14321007,20.698535,6.9380117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 1.122 v -8.978 c 1.161,0.643 2.108,1.099 2.842,1.368 0.733,0.268 1.374,0.402 1.921,0.402 1.295,0 2.282,-0.384 2.964,-1.15 0.68,-0.768 1.021,-1.88 1.021,-3.338 v -8.302 l 0.503,-0.475 1.554,-0.143 v -1.065 H 5.511 v 1.065 l 1.381,0.143 0.504,0.475 v 7.798 c 0,1.102 -0.231,1.885 -0.691,2.346 -0.461,0.459 -1.224,0.69 -2.288,0.69 -0.47,0 -0.979,-0.079 -1.524,-0.237 C 2.346,-9.56 1.756,-9.802 1.122,-10.128 v -9.87 l 0.519,-0.475 1.395,-0.143 v -1.065 h -6.46 v 1.065 l 1.597,0.143 0.504,0.475 v 18.027 h -2.274 v 0.921 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2580"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2582",
    transform: "matrix(0.14533662,0,0,-0.14321007,23.983516,8.0629842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -3.337 h -1.453 l -0.231,2.086 c -0.393,0.21 -0.767,0.369 -1.122,0.475 -0.355,0.105 -0.71,0.158 -1.064,0.158 -0.768,0 -1.367,-0.188 -1.799,-0.562 -0.432,-0.374 -0.647,-0.896 -0.647,-1.567 0,-0.547 0.172,-1.013 0.518,-1.396 0.345,-0.383 1.007,-0.811 1.985,-1.281 0.154,-0.077 0.388,-0.186 0.706,-0.33 1.112,-0.509 1.918,-0.97 2.417,-1.382 0.364,-0.287 0.641,-0.649 0.834,-1.086 0.191,-0.436 0.288,-0.919 0.288,-1.446 0,-1.381 -0.488,-2.462 -1.461,-3.244 -0.974,-0.781 -2.324,-1.173 -4.05,-1.173 -0.71,0 -1.389,0.051 -2.036,0.151 -0.647,0.101 -1.244,0.257 -1.791,0.468 v 3.827 h 1.41 l 0.359,-2.504 c 0.413,-0.239 0.828,-0.417 1.245,-0.532 0.417,-0.115 0.837,-0.173 1.259,-0.173 0.834,0 1.503,0.219 2.007,0.656 0.504,0.436 0.755,1.008 0.755,1.718 0,0.595 -0.172,1.087 -0.518,1.475 -0.344,0.389 -1.17,0.88 -2.474,1.475 -1.477,0.662 -2.482,1.285 -3.014,1.87 -0.532,0.585 -0.799,1.309 -0.799,2.173 0,1.314 0.456,2.331 1.367,3.049 0.912,0.72 2.197,1.079 3.856,1.079 0.662,0 1.277,-0.054 1.849,-0.165 C -1.034,0.372 -0.499,0.211 0,0",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2584"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2586",
    transform: "matrix(0.14533662,0,0,-0.14321007,12.760234,11.815117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.118,-0.618 -0.287,-1.214 -0.904,-1.332 l -30.82,-5.889 c -0.617,-0.118 -1.214,0.286 -1.332,0.905 l -9.634,50.421 c -0.119,0.618 0.287,1.214 0.905,1.333 l 30.818,5.888 c 0.618,0.118 1.214,-0.287 1.332,-0.904 z m -14.7,-12.724 c -1.79,-0.341 -3.52,0.832 -3.862,2.623 -0.342,1.791 0.833,3.52 2.623,3.863 1.791,0.342 3.52,-0.832 3.862,-2.623 0.343,-1.791 -0.832,-3.52 -2.623,-3.863 m -18.402,62.941 c -0.035,0.184 0.086,0.363 0.271,0.398 l 11.632,2.223 c 0.184,0.035 0.363,-0.086 0.398,-0.271 l 10e-4,-0.006 c 0.036,-0.186 -0.086,-0.364 -0.27,-0.4 l -11.631,-2.223 c -0.186,-0.035 -0.364,0.086 -0.4,0.272 z m 18.98,7.754 -27.18,-5.194 c -3.552,-0.678 -5.881,-4.108 -5.202,-7.66 l 10.98,-57.46 c 0.678,-3.552 4.107,-5.881 7.66,-5.202 l 27.179,5.193 c 3.552,0.679 5.881,4.109 5.203,7.661 l -10.98,57.46 c -0.679,3.551 -4.108,5.88 -7.66,5.202",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2588"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2590",
    transform: "matrix(0.14533662,0,0,-0.14321007,11.128318,9.8787014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -15.758,-3.012 c -1.301,-0.248 -2.567,0.613 -2.816,1.913 l -3.011,15.757 c -0.248,1.301 0.612,2.569 1.912,2.817 l 15.758,3.01 c 1.301,0.249 2.567,-0.612 2.816,-1.912 L 1.912,2.815 C 2.16,1.516 1.3,0.248 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2592"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2594",
    transform: "matrix(0.14533662,0,0,-0.14321007,11.076942,9.5036194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.427,-0.185 -0.858,-0.346 -1.305,-0.431 -1.336,-0.256 -2.801,0.166 -4.138,-0.09 -1.338,-0.255 -2.546,-1.187 -3.883,-1.443 -1.336,-0.255 -2.802,0.166 -4.139,-0.089 -1.433,-0.274 -2.544,-1.188 -2.544,-1.188 l -1.712,8.961 c 0,0 1.207,0.931 2.544,1.187 1.336,0.256 2.803,-0.166 4.139,0.089 1.337,0.256 2.537,1.187 3.881,1.443 1.345,0.257 2.804,-0.166 4.14,0.09 0.448,0.085 0.873,0.246 1.302,0.433 z",
    style: {
      fill: "#006bb5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2598",
    transform: "matrix(0.14533662,0,0,-0.14321007,10.865612,8.4143061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.426,-0.186 -0.857,-0.346 -1.304,-0.431 -1.337,-0.256 -2.802,0.166 -4.138,-0.09 h -0.002 c -1.337,-0.255 -2.545,-1.187 -3.881,-1.443 -1.336,-0.255 -2.803,0.166 -4.14,-0.089 -1.432,-0.274 -2.543,-1.187 -2.543,-1.187 l -0.259,1.353 c 0,0 1.207,0.932 2.544,1.188 1.336,0.256 2.803,-0.166 4.139,0.089 1.337,0.256 2.537,1.186 3.881,1.443 1.346,0.257 2.805,-0.166 4.141,0.09 0.447,0.085 0.873,0.246 1.301,0.432 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2602",
    transform: "matrix(0.14533662,0,0,-0.14321007,10.936139,8.7773587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.427,-0.186 -0.858,-0.346 -1.305,-0.432 -1.336,-0.255 -2.802,0.167 -4.138,-0.089 h -0.002 c -1.337,-0.255 -2.544,-1.188 -3.881,-1.443 -1.336,-0.256 -2.803,0.166 -4.139,-0.089 -1.433,-0.274 -2.544,-1.188 -2.544,-1.188 l -0.259,1.353 c 0,0 1.207,0.933 2.544,1.188 1.337,0.256 2.803,-0.166 4.139,0.09 1.337,0.255 2.537,1.185 3.881,1.443 1.346,0.256 2.805,-0.166 4.141,0.089 0.448,0.086 0.874,0.246 1.301,0.432 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2604"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2606",
    transform: "matrix(0.14533662,0,0,-0.14321007,11.006543,9.1405674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.427,-0.185 -0.858,-0.346 -1.305,-0.431 -1.336,-0.256 -2.801,0.166 -4.138,-0.09 h -0.002 c -1.336,-0.255 -2.544,-1.187 -3.881,-1.443 -1.336,-0.255 -2.802,0.166 -4.139,-0.09 -1.433,-0.273 -2.544,-1.186 -2.544,-1.186 l -0.259,1.353 c 0,0 1.207,0.933 2.544,1.188 1.337,0.256 2.803,-0.166 4.139,0.09 1.337,0.255 2.537,1.185 3.881,1.442 1.346,0.257 2.805,-0.165 4.141,0.091 0.448,0.085 0.874,0.245 1.301,0.431 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2608"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2610",
    transform: "matrix(0.14533662,0,0,-0.14321007,11.076942,9.5036194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.427,-0.185 -0.858,-0.346 -1.305,-0.431 -1.336,-0.256 -2.801,0.166 -4.138,-0.09 h -0.002 c -1.336,-0.255 -2.544,-1.187 -3.881,-1.443 -1.336,-0.255 -2.802,0.166 -4.139,-0.089 -1.433,-0.274 -2.544,-1.188 -2.544,-1.188 l -0.258,1.354 c 0,0 1.206,0.932 2.543,1.188 1.337,0.255 2.803,-0.166 4.139,0.089 1.337,0.256 2.537,1.186 3.881,1.443 1.346,0.257 2.805,-0.166 4.142,0.09 0.447,0.086 0.873,0.245 1.3,0.431 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2612"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2614",
    transform: "matrix(0.14533662,0,0,-0.14321007,9.3225441,7.625806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.909,-1.564 2.763,-3.333 4.074,-4.525 1.001,-0.91 2.035,-2.042 2.3,-3.427 1.233,-6.457 -8.064,-8.183 -9.328,-1.935 -0.305,1.506 0.231,2.848 0.855,4.183 C -1.273,-3.937 -0.372,-1.939 0,0",
    style: {
      fill: "#006bb5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2616"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2618",
    transform: "matrix(0.14533662,0,0,-0.14321007,9.3919407,9.3026532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.352,-0.673 c 0,0 0.672,-0.275 1.421,-0.264 0,0 -0.45,0.241 -1.069,0.937",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2620"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2622",
    transform: "matrix(0.14533662,0,0,-0.14321007,9.1219913,8.5505139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0.747,-0.488 c 0,0 -2.027,-2.357 0.831,-4.508 L 1.225,-5.758 C -2.424,-3.378 0,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2624"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2626",
    transform: "matrix(0.14533662,0,0,-0.14321007,25.794266,9.5999858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 4.417 C -1.583,4.216 -2.712,3.89 -3.389,3.438 -4.064,2.987 -4.402,2.34 -4.402,1.496 c 0,-0.613 0.206,-1.11 0.618,-1.489 0.413,-0.379 0.955,-0.569 1.626,-0.569 0.306,0 0.637,0.048 0.993,0.145 C -0.811,-0.321 -0.423,-0.182 0,0 m 0,-1.438 c -1.056,-0.682 -2.026,-1.193 -2.913,-1.533 -0.888,-0.341 -1.705,-0.51 -2.453,-0.51 -1.267,0 -2.3,0.378 -3.101,1.136 -0.801,0.757 -1.201,1.736 -1.201,2.935 0,0.901 0.252,1.712 0.755,2.431 0.504,0.72 1.173,1.233 2.007,1.54 0.672,0.25 1.599,0.527 2.784,0.835 1.184,0.306 2.578,0.627 4.18,0.963 v 0.864 c 0,0.949 -0.279,1.669 -0.835,2.158 -0.556,0.488 -1.371,0.733 -2.446,0.733 H -3.684 V 7.05 h -3.509 c -0.653,0 -1.111,0.091 -1.374,0.273 -0.264,0.182 -0.396,0.489 -0.396,0.921 0,0.969 0.729,1.815 2.187,2.539 1.458,0.725 3.26,1.086 5.409,1.086 1.305,0 2.417,-0.168 3.338,-0.503 C 2.892,11.03 3.606,10.531 4.114,9.869 4.422,9.476 4.642,9.019 4.776,8.495 4.91,7.973 4.978,7.126 4.978,5.956 V 5.625 -1.064 L 5.294,-1.41 6.92,-1.597 V -3.093 H 0.402 Z",
    style: {
      fill: "#fbd200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2628"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2630",
    transform: "matrix(0.14533662,0,0,-0.14321007,30.59718,9.7812322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.115,-0.01 0.239,-0.018 0.374,-0.021 0.134,-0.005 0.292,-0.008 0.475,-0.008 1.515,0 2.649,0.463 3.402,1.388 0.753,0.926 1.13,2.319 1.13,4.179 0,1.44 -0.324,2.53 -0.972,3.274 C 3.763,9.555 2.811,9.927 1.554,9.927 1.313,9.927 1.067,9.917 0.812,9.897 0.559,9.879 0.283,9.85 -0.015,9.812 Z m -6.877,-8.316 v 1.683 l 1.684,0.115 0.316,0.447 V 9.955 h -2.058 v 1.453 l 5.407,1.698 H 0 v -1.971 c 1.178,0.729 2.157,1.24 2.938,1.533 0.781,0.292 1.521,0.438 2.22,0.438 1.638,0 3.003,-0.668 4.095,-2.006 1.092,-1.339 1.638,-3.043 1.638,-5.116 0,-2.339 -0.779,-4.227 -2.335,-5.661 C 7,-1.11 4.933,-1.827 2.356,-1.827 2.098,-1.827 1.789,-1.815 1.43,-1.792 1.07,-1.768 0.594,-1.731 0,-1.684 V -6.216 L 0.386,-6.575 2.259,-6.69 v -1.626 z",
    style: {
      fill: "#fbd200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2632"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2634",
    transform: "matrix(0.14533662,0,0,-0.14321007,28.035767,9.7812322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.115,-0.01 0.239,-0.018 0.374,-0.021 0.134,-0.005 0.293,-0.008 0.475,-0.008 1.515,0 2.649,0.463 3.402,1.388 0.753,0.926 1.13,2.319 1.13,4.179 0,1.44 -0.324,2.53 -0.971,3.274 C 3.763,9.555 2.811,9.927 1.554,9.927 1.313,9.927 1.067,9.917 0.812,9.897 0.559,9.879 0.283,9.85 -0.015,9.812 Z m -6.877,-8.316 v 1.683 l 1.684,0.115 0.316,0.447 V 9.955 h -2.058 v 1.453 l 5.407,1.698 H 0 v -1.971 c 1.178,0.729 2.157,1.24 2.938,1.533 0.781,0.292 1.521,0.438 2.22,0.438 1.638,0 3.003,-0.668 4.095,-2.006 1.092,-1.339 1.638,-3.043 1.638,-5.116 0,-2.339 -0.779,-4.227 -2.334,-5.661 C 7,-1.11 4.933,-1.827 2.356,-1.827 2.098,-1.827 1.789,-1.815 1.43,-1.792 1.07,-1.768 0.594,-1.731 0,-1.684 V -6.216 L 0.386,-6.575 2.259,-6.69 v -1.626 z",
    style: {
      fill: "#fbd200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2636"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2638",
    transform: "matrix(0.14533662,0,0,-0.14321007,33.07501,9.2661485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.776,0 1.443,-0.276 2,-0.827 2.556,-1.379 2.834,-2.048 2.834,-2.835 2.834,-3.593 2.556,-4.242 2,-4.784 1.443,-5.326 0.776,-5.597 0,-5.597 c -0.758,0 -1.408,0.269 -1.95,0.806 -0.541,0.537 -0.813,1.189 -0.813,1.956 0,0.797 0.269,1.468 0.806,2.015 C -1.42,-0.273 -0.768,0 0,0 M 2.806,10.991 0.892,1.18 h -1.683 l -1.914,9.682 c -0.02,0.086 -0.038,0.192 -0.058,0.317 -0.105,0.575 -0.158,0.944 -0.158,1.107 0,0.758 0.271,1.369 0.813,1.835 0.542,0.465 1.254,0.697 2.136,0.697 0.883,0 1.595,-0.235 2.137,-0.705 0.542,-0.469 0.813,-1.079 0.813,-1.827 0,-0.135 -0.014,-0.311 -0.043,-0.532 C 2.906,11.533 2.862,11.279 2.806,10.991",
    style: {
      fill: "#fbd200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2420-2",
    transform: "matrix(0.14533662,0,0,-0.14321007,37.307372,5.0446496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -54.058",
    style: {
      fill: "none",
      stroke: "#1b1768",
      strokeWidth: 2.373,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2422-5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.ea60dce5.svg";
export { ForwardRef as ReactComponent };